export const StorageTypeArray = [
  "Składowanie płaskie",
  "Składowanie wysokie",
  "Półki",
];
export const StoragePlaceArray = ["Wewnątrz", "Na zewnątrz"];
export const FiscalBreakdownArray = [
  "Skład celny",
  "Magazyn celny",
  "Magazyn zwykły",
];
export const TemperatureConditionArray = [
  "Nieogrzewany",
  "Chłodnia",
  "Ogrzewany",
  "Kontrolowane",
];
